import React from 'react';
import { NavLink } from 'react-router-dom';
// import { GridLoader } from 'react-spinners';
import { NotificationManager } from 'react-notifications';
import * as moment from 'moment';
import DatePicker from 'react-datepicker';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import 'react-notifications/lib/notifications.css';
import * as absencesActions from '../../../store/portal';
import * as lvgActions from '../../../store/admin';
import { bindActionCreators } from 'redux';
import { ExportXlsxCsv } from './export-xlsx-csv';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import { utilService } from '../../../common/utils';
import { config } from '../../../config/config';
import { deviceDetect } from 'react-device-detect';
import cx from 'classnames';

let studentList = []
let single_digit_list = [7, 8, 9]
let double_digit_list = [10, 11, 12, 13]
let monthNames = {
  "Term 1": ["January", "February", "March"],
  "Term 2": ["April", "May", "June"],
  "Term 3": ["July", "August", "September"],
  "Term 4": ["October", "November", "December"]
}

class LVGoalsPDF extends React.Component {
  constructor(props) {
    super(props);
    this.actionsButtonFormatter = this.actionsButtonFormatter.bind(this);
    this.statusFormatter = this.statusFormatter.bind(this);
    this.removeQueue = this.removeQueue.bind(this);

    this.state = {
      username: '',
      year: new Date().getFullYear(),
      semester: this.setSemester(),
      selected_year: 7,
      edit_student: false,
      is_error: false,
      is_saving: false,
      downloading_pdf: false,
    };
  }

  setSemester() {
    const month = new Date().toLocaleString("default", { month: "long" })
    for (var mon in monthNames) {
      if (monthNames[mon].includes(month)) {
        return mon
      }
    }
  }

  componentDidMount() {
    this.props.getStoredPDFStatistics({
      token: this.props.token,
      params: '',
    })
    this.interval = setInterval(() => {
      this.props.getStoredPDFStatistics({
        token: this.props.token,
        params: '',
      })
    }, 5000);
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevProps.parentDashboard, this.props.parentDashboard)) {
      if (this.props.parentDashboard.studentList.studentListData.students !== prevProps.parentDashboard.studentList.students) {
        if (this.props.parentDashboard.studentList.studentListData.students.length > 0) {
          this.setState({
            username: this.props.parentDashboard.studentList.studentListData.students[0].username,
            student_name: this.props.parentDashboard.studentList.studentListData.students[0].student,
          })
        }
      }
    }

    if (!_.isEqual(prevProps.larningGoalsPDF, this.props.larningGoalsPDF)) {
      if (this.props.larningGoalsPDF !== prevProps.larningGoalsPDF) {
        if (this.props.larningGoalsPDF.isSave) {
          NotificationManager.success(
            'Success message',
            'Your request to generate the PDF Reports is under process. You can check below list to know the status.'
          );
        }
      }
    }

  }

  handleDownload(e) {
    this.props.getStudentGoalsAndDownload({
      token: this.props.token,
      pathparams: this.props.user.userUid,
      params: `?is_download=` + true
    });
  }

  statusFormatter(cell, row, rowIndex) {
    let status = row['queue_status']
    console.log(status)
    if (status == 'Complete') {
      return <span style={{ "color": "green" }}> {row['queue_status']}</span >
    }
    if (status == 'Pending') {
      return <span style={{ "color": "#337ab7" }}> {row['queue_status']}</span >
    }
    if (status == 'Complete') {
      return <span style={{ "color": "red" }}> {row['queue_status']}</span >
    }
  }

  actionsButtonFormatter(cell, row, rowIndex) {
    if (row['queue_status'] === "Pending") {
      return (''
        // <div className="d-flex align-items-center nav-con">
        //   <button
        //     type="button"
        //     onClick={this.removeQueue.bind(this, cell, row, rowIndex)}
        //     className="btn btn-primary lh-0 p-3"
        //     title="Delete Subscriber"
        //   >
        //     <i className="fa fa-trash fa-w-16" aria-hidden="true" />
        //   </button>
        // </div>
      )
    } else {
      return ''
    }
  }

  handleInputChange(flag, e) {
    let value = e.target.value;

    if (flag === 'change_year') {
      this.setState({
        year: value,
      })
    }
    if (flag === 'change_term') {
      this.setState({
        semester: value,
      })
    }
    if (flag === 'change_username') {
      if (value !== "13") {
        this.setState({
          selected_year: parseInt(value),
          edit_student: false,
          username: '',
          is_error: false,
        })
      }
      else {
        this.setState({
          selected_year: parseInt(value),
          edit_student: true
        })
      }
    }
    if (flag == 'change_student') {
      this.setState({
        username: value,
      })
    }
  }

  handleSubmit() {
    this.setState({
      is_saving: true
    })
    let year_selected = ""
    if (single_digit_list.includes(this.state.selected_year)) {
      year_selected = this.state.year + " Year  " + this.state.selected_year
    }
    if (double_digit_list.includes(this.state.selected_year)) {
      year_selected = this.state.year + " Year " + this.state.selected_year
    }

    if (this.state.selected_year !== 13 && this.state.year) {
      this.props.saveLVGoalsPDF({
        token: this.props.token,
        method: 'POST',
        params: '?selected_year=' + year_selected + '&semester=' + this.state.semester + '&year=' + this.state.year,
      })
    }
    else if (this.state.selected_year === 13 && this.state.year) {
      if (!this.state.username) {
        this.setState({
          is_error: true
        })
      } else {
        this.props.saveLVGoalsPDF({
          token: this.props.token,
          method: 'POST',
          params: '?selected_year=' + year_selected + '&username=' + this.state.username + '&semester=' + this.state.semester + '&year=' + this.state.year,
        })
        this.setState({
          is_error: false,
        })
      }
    }
    this.setState({
      is_saving: false
    })

    this.props.getStoredPDFStatistics({
      token: this.props.token,
      params: '',
    })
  }

  removeQueue(cell, row, rowIndex) {
    this.props.removeQueue({
      token: this.props.token,
      method: 'POST',
      params: '?queuestatisticsUid=' + row['queuestatisticsUid'],
    })
  }
  render() {
    const lgColumns = [
      {
        dataField: 'queuestatisticsUid',
        text: 'QueuestatisticsUid',
      },
      {
        dataField: 'created_at',
        text: 'Created At',
      },
      {
        dataField: 'created_by',
        text: 'Created By',
      },
      {
        dataField: 'form_run',
        text: 'Form Run',
      },
      {
        dataField: 'is_error',
        text: 'Is Error',
      },
      {
        dataField: 'message',
        text: 'Message',
      },
      {
        dataField: 'queue_status',
        text: 'Status',
        formatter: this.statusFormatter,
      },
      {
        dataField: 'updated_at',
        text: 'Updated At',
      },
      {
        dataField: 'semester',
        text: 'Semester',
      },
      {
        dataField: 'academic_year',
        text: 'Academic Year',
      },
      // {
      //   dataField: 'actions',
      //   text: 'Actions',
      //   formatter: this.actionsButtonFormatter,
      // }
    ];

    const larningGoalsPDFList = (
      <div className="postsTable">
        <BootstrapTable
          bootstrap4
          keyField="pageUid"
          wrapperClasses="table-responsive"
          data={this.props.queuePDF}
          loading={true}
          columns={lgColumns}
          pagination={paginationFactory()}
          noDataIndication={indication}
        />
      </div>
    );
    studentList =
      this.props.parentDashboard.studentList.studentListData.students !==
        undefined
        ? this.props.parentDashboard.studentList.studentListData.students
        : [];

    return (
      <div>
        <div className="head-wrap d-flex align-items-center justify-content-between flex-column flex-md-row">
          <h1>LEARNING VIRTUES GOALS</h1>
          <button
            type="button"
            className="btn btn-icon p-0 flex-shrink-0 d-flex align-items-center mr-3"
            style={{ color: 'black', borderColor: '#afbf20', backgroundColor: '#afbf20', fontWeight: 'normal', textTransform: 'none' }}
            onClick={this.handleDownload.bind(this)}
            disabled={this.props.studentGoalLoading}
            title="Download Report"
          >
            <span className="pl-3 d-none d-sm-inline-block">
              Download Report
            </span>
            {/* <i className="fa fa-file-pdf-o flex-shrink-0 h3 lh-1 md-display-6 p-3" /> */}
            <i
              className={cx(
                'fa fa-file-pdf-o flex-shrink-0 h3 lh-1 md-display-6 p-3',
                {
                  'd-none': this.state.downloading_pdf,
                }
              )}
            />
            <span
              className={cx('p-3', {
                'd-none': !this.state.downloading_pdf,
              })}
            >
              <utilService.BorderSpinner
                loading={this.state.downloading_pdf}
                color="pear"
                size={1.5}
              />
            </span>
          </button>
        </div>
        <div id="accordion" className="pt-3">
          <div className="card">
            <div className="card-body">
              <div className="filters mb-2">
                {/* <form ref={(el) => (this.myFormRef = el)}> */}
                <div className="brd-1">
                  <div className="row">
                    <div className="col-md-2">
                      <div className="mt-2">
                        <label className="title-label  d-block">Year</label>
                        <select className="select_form" name="year"
                          value={this.state.year}
                          onChange={(e) => this.handleInputChange('change_year', e)} >
                          <option key={1} value="2021">2021</option>
                          <option key={2} value="2022">2022</option>
                          <option key={3} value="2023">2023</option>
                          <option key={4} value="2024">2024</option>
                        </select>
                        <div className="errorMsg"></div>
                      </div>
                    </div>
                    <div className="col-md-3">
                      <label className="title-label  d-block">Term </label>
                      <select className="select_form" name="semester"
                        value={this.state.semester}
                        onChange={(e) => this.handleInputChange('change_term', e)} >
                        <option key={1} value="Term 1">Term 1</option>
                        <option key={2} value="Term 2">Term 2</option>
                        <option key={3} value="Term 3">Term 3</option>
                        <option key={4} value="Term 4">Term 4</option>
                      </select>
                      <div className="errorMsg"></div>
                    </div>
                    <div className="col-md-4">
                      <label className="title-label  d-block">Students </label>
                      <select className="select_form" name="username"
                        value={this.state.selected_year}
                        onChange={(e) => this.handleInputChange('change_username', e)} >
                        <option value={7}>All Year 7 Students</option>
                        <option value={8}>All Year 8 Students</option>
                        <option value={9}>All Year 9 Students</option>
                        <option value={10}>All Year 10 Students</option>
                        <option value={11}>All Year 11 Students</option>
                        <option value={12}>All Year 12 Students</option>
                        <option value={13}>Individual Student</option>
                        {/* {studentList && studentList.map((value, index) => (
                          <option value={JSON.stringify({ 'username': value.username, 'name': value.student })}>{value.student}</option>
                        ))} */}
                      </select>
                      <div className="errorMsg"></div>
                    </div>
                    <div className="col-md-3" title="To enable this field select 'Individual Student' from Students droplist.">
                      <label className="title-label  d-block">Student Username :</label>
                      <input type="text"
                        onChange={(e) => this.handleInputChange('change_student', e)}
                        placeholder="eg: abat12345"
                        readOnly={!this.state.edit_student}
                        className={
                          this.state.selected_year == 13 ? 'w-100 input-highlight' : 'w-100'
                        }
                        value={this.state.username}
                      />
                      {this.state.is_error && <span className='d-block' style={{ "color": "red" }}>*Please enter valid value </span>}
                    </div>
                  </div>
                </div>
                <div className="head-wrap d-flex align-items-center justify-content-between flex-column flex-md-row">
                  <div className="d-flex">
                    <button disabled={this.state.is_saving} style={{ backgroundColor: this.state.is_saving && '#6f7881ba' }} onClick={this.handleSubmit.bind(this)} className="mr-1">Create/Replace PDFs</button>
                  </div>
                </div>
                {/* </form> */}
              </div>
            </div>
          </div>
        </div>
        {this.props.parentDashboardActionLoading === true || this.state.is_saving || this.props.studentGoalLoading && (
          <utilService.GridSweetLoader
            loading={true}
          />
        )}
        <h3>Learning Goals PDF Requests</h3>
        {larningGoalsPDFList}
        <div className="overlay"></div>
      </div>
    );
  }
}

function indication() {
  return 'No records found!';
}

/**
 * It is called every time the store state changes.
 * It receives the entire store state, and should return an object of data this component needs.
 * @param {*} state : Getting updated state object from reducer
 * @param {*} props : Getting props of this component
 */
function mapStateToProps(state) {
  // console.log('State ==========', state);
  return {
    parentDashboardActionLoading: state.parentDashboard.actionsloading,
    larningGoalsPDFActionLoading: state.larningGoalsPDF.actionsloading,
    token: state.user.cognito_data.token,
    user: state.user.user,
    parentDashboard: state.parentDashboard,
    larningGoalsPDF: state.larningGoalsPDF,
    pre_signed_URL: state.studentGoals.pre_signed_URL || '',
    studentGoalLoading: state.studentGoals ? state.studentGoals.actionsloading : false,
    queuePDF: Object.values(state.queuePDF.byId),
  };
}
/**
 * connect() function connects a react component to a redux store.
 */
export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(Object.assign({}, absencesActions, lvgActions), dispatch)
)(LVGoalsPDF);
